import React from 'react'

import { Layout } from 'components/Layout'

import PaginationItem from './PaginationItem'
import usePagination from './usePagination'

import type { PaginationProps } from './Pagination.types'

function Pagination(props: PaginationProps): JSX.Element {
  const {
    boundaryCount = 1,
    count,
    disabled = false,
    onChange,
    page,
    siblingCount = 1,
    ...others
  } = props

  const items = usePagination({ boundaryCount, count, disabled, onChange, page, siblingCount })

  return (
    <nav aria-label="pagination navigation" {...others}>
      <Layout.Group space="none" align="center">
        {items.map((item) => (
          <PaginationItem {...item} key={`${item.itemType}${item.page || ''}`} />
        ))}
      </Layout.Group>
    </nav>
  )
}

export default Pagination
